// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__21Ph3","title":"Images90_title__2pTXo","images":"Images90_images__3Xnjx"};